import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import subtotalSalesTax from './subtotalSalesTax.selector';

const creditAmountSel = state => state.salestaxes.creditAmount;
const subtotalSalesTaxSel = state => subtotalSalesTax(state);

const selector = createSelector(
  [creditAmountSel, subtotalSalesTaxSel],
  (_credit, _subtotal) => {
    const credit = Number(_credit);
    const subtotal = Number(_subtotal);

    let value = 0;
    if (credit <= subtotal) {
      value = subtotal - credit;
    }

    return precise(value);
  },
);

export default selector;
